import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { matchLeaderboardQueryOptions } from "@/api/ranking";
import { matchBadgesQueryOptions } from "@/api/badges";
import { useSelectedMatch } from "@/context/matchContext";
import { useSelectedTeam } from "@/context/teamContext";
import { AchievementBadges } from "@/components/general/Dashboard/Overview/AchievementBadges";
import { TestBanner } from "@/components/general/common/TestBanner";
import { useFeatureFlags } from "@/context/featureFlagsContext";
import { OverviewStatsTable } from "@/components/general/Dashboard/Overview/OverviewStatsTable";
import { LeaderboardMobileCards } from "@/components/general/Dashboard/Overview/LeaderboardMobileCards";
import { leaderboardTableColumns } from "@/components/general/Dashboard/Overview/LeaderboardTableColumns";

export const OverviewPage = () => {
    const { matchIds } = useSelectedMatch();
    const { teamId } = useSelectedTeam();
    const { isEnabled, isNew } = useFeatureFlags();

    const { data: leaderboardData, isLoading: isLeaderboardLoading } = useQuery(
        matchLeaderboardQueryOptions(matchIds.length > 0 ? matchIds : undefined, teamId)
    );

    const { data: badgesData, isLoading: isBadgesLoading } = useQuery(
        matchBadgesQueryOptions(matchIds.length > 0 ? matchIds : undefined, teamId)
    );

    const playerData = useMemo(() => {
        const skaters = leaderboardData?.skaterStats ?? [];
        const goalies = leaderboardData?.goalieStats ?? [];
        return [...skaters, ...goalies];
    }, [leaderboardData]);

    return (
        <div className="flex flex-col gap-6 h-full min-h-0">
            {isEnabled("test") && <TestBanner showNewBadge={isNew("test")} />}
            <div className="grid grid-cols-1 [@media(min-width:1430px)]:grid-cols-[5fr_4fr] gap-6 flex-1 min-h-0">
                <div id="onboarding-dashboard-leaderboard" className="flex flex-col min-h-0">
                    <h3 className="text-lg font-headline font-bold mb-3 shrink-0" style={{ color: "#050066" }}>
                        Match Total Points Leaderboard
                    </h3>
                    <div className="flex-1 min-h-0 overflow-y-auto lg:hidden">
                        <LeaderboardMobileCards data={playerData} isLoading={isLeaderboardLoading} />
                    </div>
                    <div className="hidden lg:flex flex-1 min-h-0 overflow-y-auto overflow-x-hidden rounded-xl">
                        <OverviewStatsTable
                            columns={leaderboardTableColumns}
                            data={playerData}
                            isLoading={isLeaderboardLoading}
                            noHorizontalScroll
                        />
                    </div>
                </div>

                <div id="onboarding-dashboard-badges">
                    <AchievementBadges badges={badgesData || []} isLoading={isBadgesLoading} />
                </div>
            </div>
        </div>
    );
};
